function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.69995 18.7444C4.69995 17.1444 3.5 14.6445 3.5 11.9445C3.5 7.14446 7.40005 3.14441 12.3 3.14441C15.1 3.14441 17.5 4.44446 19.1 6.44446",
  stroke: "white",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9 15.4445L12.1 13.2444V8.44446",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.90002 21.0444C9.28662 21.0444 9.59998 20.731 9.59998 20.3444C9.59998 19.9578 9.28662 19.6444 8.90002 19.6444C8.51343 19.6444 8.19995 19.9578 8.19995 20.3444C8.19995 20.731 8.51343 21.0444 8.90002 21.0444Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7 21.6444C12.0866 21.6444 12.4 21.3311 12.4 20.9445C12.4 20.5579 12.0866 20.2444 11.7 20.2444C11.3134 20.2444 11 20.5579 11 20.9445C11 21.3311 11.3134 21.6444 11.7 21.6444Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6 21.4445C14.9866 21.4445 15.3 21.131 15.3 20.7444C15.3 20.3578 14.9866 20.0444 14.6 20.0444C14.2134 20.0444 13.9 20.3578 13.9 20.7444C13.9 21.131 14.2134 21.4445 14.6 21.4445Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4 7.54445L20.3 5.14442C20.5 4.94442 20.8 5.14444 20.8 5.34444L21 8.44447C21 8.84447 20.8 9.04447 20.4 8.94447L17.4 8.04445C17.3 7.94445 17.2 7.74445 17.4 7.54445Z",
  fill: "white"
});

var SvgPending = function SvgPending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pending.0b2775ca.svg";
export { ForwardRef as ReactComponent };